<template>
  <div>
    <LoadingScreen v-if="!renderPresentationDetail" />
    <PresentationEditor v-if="currentUser.id" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

// components
import LoadingScreen from '@/components-v2/common/loading/LoadingScreen.vue'
import PresentationEditor from '@/components-v2/presentation-editor/PresentationEditor.vue'

export default {
  components: {
    LoadingScreen,
    PresentationEditor,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      renderPresentationDetail: (state) => state.renderPresentationDetail,
    }),
  },
  created() {
    this.$store.state.renderPresentationDetail = false
  },
  destroyed() {
    this.$store.state.renderPresentationDetail = false
    this.unsetPresentationState()
    if (document.body.classList.contains('no-scroll-template')) {
      document.body.classList.remove('no-scroll-template')
    }
  },
  methods: {
    ...mapActions(['setPresentationAction', 'setSlideActiveAction']),
    async unsetPresentationState() {
      // TECH DEBT: setSlideActiveAction must be called before setPresentationAction because
      // we handle the action the wrong way in the store (use the presentation data to mutate the slide data)
      // Check setSlideActiveAction for more context
      // await this.setSlideActiveAction({})
      // this.setPresentationAction({})
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
